import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { DropzoneDialog } from 'material-ui-dropzone'

import { Notification } from 'src/components/Notification'

interface ImageUploadProps {
  open: boolean
  upload: (file: File) => Promise<null>
  onSave: () => void
  handleClose: () => void
}

export const ImageUpload = (props: ImageUploadProps) => {
  const { open, upload, onSave, handleClose } = props
  const [dropzoneOpen, setDropzoneOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const { isLoading, mutate: uploadImage } = useMutation(upload, {
    onSuccess: () => {
      onSave()
      setDropzoneOpen(false)
    },
    onError: (error: AxiosError) => {
      const errorStr = error?.response?.data?.file || error?.response?.data || error
      toast.error(() => <Notification message={`Failed to upload photo: ${errorStr}`} />)
      setErrorMessage(`ERROR: ${errorStr}`)
    },
  })
  const onImageSelect = (files: File[]) => {
    uploadImage(files[0])
  }

  useEffect(() => {
    setDropzoneOpen(open)
  }, [setDropzoneOpen, open])

  return (
    <>
      <DropzoneDialog
        inputProps={{
          disabled: isLoading,
        }}
        open={open && dropzoneOpen}
        onSave={onImageSelect}
        showPreviews={true}
        filesLimit={1}
        maxFileSize={5000000}
        dropzoneText={errorMessage || 'Drag and drop an image file here or click'}
        submitButtonText={isLoading ? 'Uploading...' : 'Upload'}
        onClose={() => {
          setDropzoneOpen(false)
          handleClose()
        }}
      />
    </>
  )
}
